export default "__VITE_ASSET__4Q1p8F$O__"